import { CommonModule } from "@angular/common";
import { Component, Inject } from "@angular/core";
import {
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from "@angular/forms";
import { MatAutocompleteModule } from "@angular/material/autocomplete";
import { MatButtonModule } from "@angular/material/button";
import { MatNativeDateModule } from "@angular/material/core";
import { MatDatepickerModule } from "@angular/material/datepicker";
import {
  MAT_DIALOG_DATA,
  MatDialogModule,
  MatDialogRef,
} from "@angular/material/dialog";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatInputModule } from "@angular/material/input";
import { Aircraft } from "src/app/models";

export interface AircraftDialogData {
  aircraft: Aircraft;
}
export interface AircraftDialogResult {
  action: "save" | "cancel";
  aircraft?: Aircraft;
}

@Component({
  selector: "app-aircraft-detail-dialog",
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MatDialogModule,
    MatFormFieldModule,
    MatInputModule,
    MatAutocompleteModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatButtonModule,
  ],
  templateUrl: "./aircraft-detail.component.html",
  styleUrls: ["./aircraft-detail.component.scss"],
})
export class AircraftDetailComponent {
  public form: FormGroup;

  constructor(
    private fb: FormBuilder,
    private dialogRef: MatDialogRef<AircraftDialogResult>,
    @Inject(MAT_DIALOG_DATA) public data: AircraftDialogData
  ) {}

  ngOnInit(): void {
    const a = this.data.aircraft;
    this.form = this.fb.group({
      id: [a.id],
      code: [a.code, [Validators.required]],
      model: [a.model, [Validators.required]],
      condition: [a.condition ?? ""],
    });
  }

  onCancel(): void {
    this.dialogRef.close({ action: "cancel" });
  }

  onSave(): void {
    if (this.form.invalid) return;
    this.dialogRef.close({
      action: "save",
      aircraft: this.form.value as Aircraft,
    });
  }
}
